import { useFetch } from "@common/hooks/useFetch";
import { useContext } from "react";
import { NumberOfferContext } from "../../../App";
import { ICart } from "../ICart";
import { portinRoute } from "@api-routes";
import { getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

export const useDeletePortin = () => {
    const [deletePortinState, { deleteCall }] = useFetch();
    const { setNumberOfferSelected } = useContext(NumberOfferContext);

    const deletePortin = (cartOfferId: number): Promise<ICart | undefined> => {
        return deleteCall<ICartResponse>(portinRoute(cartOfferId), {
            isSecured: keycloakUtils.isAuthenticated(),
        }).then((newCartResponse) => {
            if (newCartResponse) {
                const newCart = getResponseToState(newCartResponse);

                setNumberOfferSelected(newCart.offers.length);

                return newCart;
            }

            return undefined;
        });
    };

    return { deletePortinState, deletePortin };
};
